import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from '../login/login.guard';
import { StockComponent } from '../stock/stock.component';

const routes: Routes = [
  {
    path: 'stock',
    component: StockComponent,
    canActivate : [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StockRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock-routing.module.ts